export enum PipelineStageEnum {
  appointment_pending = 1,
  appointment_scheduled = 2,
  presentation_scheduled = 3,
  exclusive_pending = 4,
  exclusive_secured = 5,
  rfp_loi = 6,
  contract_lease_working = 7,
  under_contract = 8,
  on_hold = 9,
  closed_won = 10,
  closed_construction_pending = 11,
  closed_lost = 12,
}

export const pipelineStageLabels: Record<PipelineStageEnum, string> = {
  [PipelineStageEnum.appointment_pending]: 'Appointment Pending',
  [PipelineStageEnum.appointment_scheduled]: 'Appointment Scheduled',
  [PipelineStageEnum.presentation_scheduled]: 'Presentation Scheduled',
  [PipelineStageEnum.exclusive_pending]: 'Exclusive Pending',
  [PipelineStageEnum.exclusive_secured]: 'Exclusive Secured',
  [PipelineStageEnum.rfp_loi]: 'RFP/LOI',
  [PipelineStageEnum.contract_lease_working]: 'Contract/Lease Working',
  [PipelineStageEnum.under_contract]: 'Under Contract',
  [PipelineStageEnum.on_hold]: 'On Hold',
  [PipelineStageEnum.closed_won]: 'Closed - Won',
  [PipelineStageEnum.closed_construction_pending]: 'Closed - Construction Pending',
  [PipelineStageEnum.closed_lost]: 'Closed - Lost',
};
